// extracted by mini-css-extract-plugin
module.exports = {"incompleteMarketShareData":"-mb-market-share-warning-container-incompleteMarketShareData-ZMKqS8-"};